import React, { useState} from "react";
import Navbar from "react-bootstrap/Navbar";
import "../App.css";
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu/index";
export default function Navheader(props) {
    const [navbar, setNavbar] = useState(false);

  const changebackground = () => {
    if(window.scrollY >= 10){
      setNavbar(true);
    }else{
      setNavbar(false);
    }
  };

  window.addEventListener('scroll', changebackground);
  return (
    <>
        <Navbar
          collapseOnSelect
          expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={navbar ? 'navbar active' : 'navbar' }
        >
          <Navbar.Brand>
          <div className="d-flex">
                <div>
            <a target="_blank"
             href="https://www.swmc.com/">
              <img
                src ={"https://resources.swmc.com/swmc-images/sunwest-trust-white-logo.png"}
                className=" img-fluid w-50 main_logo"
                alt="Sun West logo"
              />
            </a>
            </div>
                <UserWayAccessibilityMenu
                  color="white"
                  width={40}
                  height={40}
                />
              </div>
          </Navbar.Brand>

        </Navbar>
    </>
  );
}